
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';

import ModifierPriceAddEdit from '@/views/DashView/ModifierPrice/ModifierPriceAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class ModifierPriceItem {
  id: string = '';
  modifierItemCode: string = '';
  modifierGroupCode: string = '';
  priceType: string = '';
  price: string = '';
}

@Component({
  components: {
    editor: ModifierPriceAddEdit
  }
})
export default class ModifierPriceList extends RemoteDataTable<
  ModifierPriceItem
  > {
  public pageTitle: string = 'Modifier Price List';

  public newButtonText: string = 'New Modifier Price';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),

    new RemoteDataField({
      key: 'modifierItemCode',
      label: 'Modifier Item Code'
    }),
    new RemoteDataField({
      key: 'modifierGroupCode',
      label: 'Modifier Group Code'
    }),
    new RemoteDataField({ key: 'priceType', label: 'Price Type' }),
    new RemoteDataField({ key: 'price', label: 'Price' })
  ];

  // to get page data
  get items(): ModifierPriceItem[] {
    return this.$store.getters.GetAllModifierPrice;
  }

  get paging(): ModifierPriceItem[] {
    return this.$store.getters.PagingModifierPrice;
  }

  get sorting(): ModifierPriceItem[] {
    return this.$store.getters.SortingModifierPrice;
  }

  get filtering(): ModifierPriceItem[] {
    return this.$store.getters.FilteringModifierPrice;
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingModifierPrice', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringModifierPrice', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.modifierPrice.pagingModifierPrice.page = 1;
    }
    this.$store.dispatch('GetAllModifierPrice');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteModifierPrice', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.modifierPrice.pagingModifierPrice.size = page;
    this.$store.dispatch('GetAllModifierPrice');
  }
}
